import { SelectProps } from '@mantine/core';
import { Editor } from '@tiptap/react';
import { useTranslation } from 'react-i18next';

import { defaultActivityThemeStyles } from 'external-modules/ui';

import { Select } from '@/components/Select';
import { DropdownArrow } from '@/icons/DropdownArrow';
import { Level } from '@/utils/tiptap/extensions/heading';
import { useUiLanguage } from '@/utils/useUiLanguage';
import { useStyles } from '@/widgets/_components/RichTextToolbar/ToolbarSelect.styles';

export type TextLevelSelectProps = {
  editor: Editor | null;
  textLevels: { value: string; label: string }[];
};

export function TextLevelSelect(props: TextLevelSelectProps) {
  const { editor, textLevels } = props;

  const { classes } = useStyles({ maxWidth: 72 });
  const { uiLanguage } = useUiLanguage();
  const { t } = useTranslation('widgets', { keyPrefix: 'headingSelect', lng: uiLanguage });

  const isActiveParagraph = editor?.isActive('paragraph');
  const isActiveHeader = editor?.isActive('heading');

  let activeHeading = textLevels[0].value;
  if (isActiveParagraph) {
    activeHeading = 'p';
  } else if (isActiveHeader) {
    activeHeading = editor?.getAttributes('heading').level?.toString();
  }
  const handleHeadingChange = (level: string) => {
    const newLevel = level === '0' ? activeHeading : level;

    let levelTag: keyof typeof defaultActivityThemeStyles.typography;
    if (newLevel === 'p') {
      levelTag = 'p';
      editor?.chain().focus().setParagraph().run();
    } else {
      levelTag = `h${level}` as keyof typeof defaultActivityThemeStyles.typography;

      editor
        ?.chain()
        .focus()
        .toggleHeading({ level: newLevel as Level })
        .setFontSize(`${defaultActivityThemeStyles.typography[levelTag].fontSize}`)
        .run();
    }
  };

  return (
    <Select
      title={t('title') ?? ''}
      classNames={{
        root: classes.selectRoot,
        option: classes.selectItem,
        input: classes.selectInput,
        section: classes.selectIcon,
        dropdown: classes.selectDropdown
      }}
      data={textLevels.map(({ label, value }) => ({ value, label: t(label) }))}
      value={activeHeading}
      onChange={handleHeadingChange as SelectProps['onChange']}
      variant="unstyled"
      withCheckIcon={false}
      leftSection={<DropdownArrow />}
      leftSectionWidth={24}
      leftSectionPointerEvents="auto"
      rightSection={<></>}
      rightSectionWidth={'0px'}
    />
  );
}
